<div class="row">
    <div class="col-12">
        <div class="d-flex flex-column">
            <div *ngIf="tableLength <= 0; else orgVerifPackageTable">
                <div class="row justify-content-center">
                    <div class="w-100 d-flex justify-content-center my-5" style="font-size:11pt;">
                        No Verification Packages exist for Organization.
                    </div>
                </div>
            </div>
            <ng-template #orgVerifPackageTable>
                <div class="d-flex justify-content-center pb-5">
                    <app-data-table
                        [dataSource]="dataSource"
                        [displayedColumns]="columns"
                        [component]="'Verification Packages'"
                        [displayLoadingIndicator]="loading"
                        [showSearch]=false
                        [tableLength]="tableLength"
                        [pageSize]="pageSize"
                        [navigateOnRowClick]=false
                        [getStatusColor]="getPackagePrimaryColorForTable"
                        [showPaginator]="false"
                        [hidePointer]="true"
                        (editVerificationPackageClickEvent)="onEditVerificationPackageClick($event)"
                        (updatePrimaryVerificationPackageClickEvent)="onUpdatePrimaryVerificationPackageClick($event)"
                        (deleteVerificationPackageClickEvent)="onDeleteVerificationPackageClick($event)">
                    </app-data-table>
                </div>
            </ng-template>
        </div>
    </div>
</div>
